/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Myrestaurant1Inputs */

const en_myrestaurant1 = /** @type {(inputs: Myrestaurant1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`My Restaurant`)
};

const de_myrestaurant1 = /** @type {(inputs: Myrestaurant1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mein Restaurant`)
};

/**
* | output |
* | --- |
* | "My Restaurant" |
*
* @param {Myrestaurant1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const myrestaurant1 = /** @type {((inputs?: Myrestaurant1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Myrestaurant1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_myrestaurant1(inputs)
	return de_myrestaurant1(inputs)
});
export { myrestaurant1 as "myRestaurant" }